import { API } from "aws-amplify";
import { action, flow, makeObservable, observable, toJS } from "mobx";
import {
    // [DEPRECATED_GRAPHQL] - Para eliminación: Estas queries se usan en métodos deprecados
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // deleteAgentFile,
    // preDeleteAgent,
   
    // putAgent,
    // getCategories,
    // getPrompt,
    getAgent,
    getUploadUrlFile,
    putUserResources,
    getResources,
    putGenerateAvatar,
    getUrlFile,
} from "../../../graphql/queries";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

class EditAgentStore {
    name = "";
    title = "";
    persona = "";
    tones = [];
    answerExtension = "";
    instructions = "";
    account = "";
    photo_url = "";
    signature = ""
    agents = [];
    files = [];
    channels = [];
    rawFiles = [];
    prompts = [];
    addConcierge = true;
    usePrompter = false;
    type = "";
    typeAgent = "";
    typeName = "";
    id = "";
    prompt_id = "";
    createdDate = "";
    updatedDate = "";
    isDuplicating = false;
    isConcierge = false;
    isLoading = false;
    isError = false;
    errorMessage = "";
    isUploadingFile = false;
    showOverlay = false;
    deleteFile = "";
    updatedAgentSuccessfully = false;
    finishedInitialLoad = false;
    actions = [];
    actionsSettings = [];
    actionsSettingsTouched = false;
    selectedCategory = null;
    selectedAgentCategory = null;
    agentCategories = [];
    llmModelSelected = null;
    conversationStarters = {
        "cs1": "",
        "cs2": "",
        "cs3": "",
        "cs4": ""
    };
    domain = '';
    agentPrompter = '';
    agentConcierge = '';
    uploadProgress = 0;
    filesWithStatus = [];
    agentConfigureMetadata = {};
    agentCreator = {};
    agentSelected = {};
    resources = [];
    usersResources = [];
    sharedSuccessfully = false;
    chosenPolicy = "";
    photoFileName = null;
    isDeleting = false;
    category = null;
    model = null;
    
    constructor() {
        makeObservable(this, {
            name: observable,
            title: observable,
            persona: observable,
            tones: observable,
            conversationStarters: observable,
            answerExtension: observable,
            instructions: observable,
            account: observable,
            files: observable,
            rawFiles: observable,
            type: observable,
            prompts: observable,
            typeAgent: observable,
            typeName: observable,
            id: observable,
            prompt_id: observable,
            createdDate: observable,
            updatedDate: observable,
            channels: observable,
            agents: observable,
            addConcierge: observable,
            usePrompter: observable,
            isConcierge: observable,
            agentPrompter: observable,
            agentConcierge: observable,
            isLoading: observable,
            isError: observable,
            errorMessage: observable,
            isUploadingFile: observable,
            deleteFile: observable,
            domain: observable,
            actions: observable,
            actionsSettings: observable,
            actionsSettingsTouched: observable,
            updatedAgentSuccessfully: observable,
            finishedInitialLoad: observable,
            uploadProgress: observable,
            filesWithStatus: observable,
            photo_url: observable,
            signature: observable,
            selectedCategory: observable,
            selectedAgentCategory: observable,
            agentCategories: observable,
            llmModelSelected: observable,
            setPhotoUrl: action,
            setSelectedCategory: action,
            setSelectedAgentCategory: action,
            setAgentCategories: action,
            agentConfigureMetadata: observable,
            agentCreator: observable,
            agentSelected: observable,
            resources: observable,
            usersResources: observable,
            sharedSuccessfully: observable,
            chosenPolicy: observable,
            onChangeName: action,
            onChangeTitle: action,
            onChangeTones: action,
            onChangeAnswerExtension: action,
            onChangeInstructions: action,
            onChangeAccount: action,
            onChangeFiles: action,
            onChangeChannels: action,
            onChangeType: action,
            onChangeTypeName: action,
            onClearError: action,
            onSetError: action,
            clear: action,
            displayDeleteFileDialog: action,
            getAgentByID: action,
            updateConversationStarter: action,
            newConversationStarter: action,
            removeConversationStarter: action,
            setFilesWithStatus: action,
            setAgentConfigureMetadata: action,
            setUsersResources: action,
            removeUserResource: action,
            setChosenPolicy: action,
            onAgentTypeChange: action,
            onChangeSignature: action,
            setSelectedPromptId: action,
            // [DEPRECATED_GRAPHQL] - Para eliminación: Estos métodos usan GraphQL queries
            // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
            
            // getAgents: flow,
            // updateAgent: flow,
            // confirmRemoveFile: flow,
            // getAgentPrompter: flow,
            getAgentConcierge: flow,
            uploadFile: flow,
            fetchResources: flow,
            updateUserResources: flow,
            uploadAgentPhoto: flow,
            fetchGenerateAvatar: flow,
            // deleteAgentFile: flow,
            // preDeleteAgent: flow,
            // fetchCategories: flow,
            photoFileName: observable,
            setPhotoFileName: action,
            downloadFile: flow,
            // getPrompts: flow,
            isDeleting: observable,
            setLlmModelSelected: action,
            category: observable,
            model: observable,
        });
    }

    setPhotoFileName = (value) => {
        this.photoFileName = value;
    };

    onChangeName = (value) => {
        this.name = value;
    };

    onChangeTitle = (value) => {
        this.title = value;
    };

    onChangeTones = (values) => {
        if (values.length) this.tones = values;
    };

    onChangeChannels = (values) => {
        if (values.length) this.channels = values;
    };

    onChangeActions = (value) => {
        this.actions = value;
    };

    onChangeActionsSettingsTouched = (type) => {
        const actionSetting = this.actionsSettings.find((setting) => setting[type])
        if (!actionSetting || !actionSetting[type] || !actionSetting[type].id || !actionSetting[type].name || !actionSetting[type].link) {
            this.actionsSettingsTouched = true
            setTimeout(() => { 
                this.actionsSettingsTouched = false
            },3000)
        }
    }

    onClearActionsSettingsTouched = () => {
        this.actionsSettingsTouched = false
    }

    onChangeActionsSettings = (value, type) => {
        const actionSetting = this.actionsSettings.find((setting) => setting[type])
        if (actionSetting) {
            actionSetting[type] = { ...value[type] }
        } else {
            this.actionsSettings.push({ [type]: { ...value[type] } })
        }
    };

    onChangeAnswerExtension = (value) => {
        this.answerExtension = value;
    };

    onChangeInstructions = (value) => {
        this.instructions = value;
    };

    onChangeAccount = (value) => {
        this.account = value;
    };

    onChangeType = (value) => {
        this.type = value;
    };

    onChangeTypeName = (value) => {
        this.typeName = value;
    };

    onChangeFiles = (value) => {
        if (typeof value === 'string') {
            this.rawFiles = [...this.rawFiles, value];
            this.files = [
                ...this.files,
                value.replace("s3://", "").split("/").splice(-1).pop(),
            ];
        } else {
            this.isError = true;
        }
    };

    onValidateTextField = (field) => {
        return this[field].length;
    };

    onValidateObjectField = (field) => {
        return Object.keys(this[field]).length;
    };

    onChangeIncludeConcierge = (value) => {
        this.addConcierge = value === "yes";
    };

    onChangeUsePrompter = (value) => {
        this.usePrompter = value === "yes";
    };

    onClearError = () => {
        this.isError = false;
    };

    onSetError = () => {
        this.isError = true;
    };

    displayDeleteFileDialog = (value) => {
        this.deleteFile = value;
    };

    updateConversationStarter(id, value){
        this.conversationStarters[id] = value;
    }

    newConversationStarter(value){
        this.conversationStarters[`cs-new-${Math.random()}`] = value;
    }

    removeConversationStarter(idx){
        const objIdx = Object.keys(this.conversationStarters)[idx]
        delete this.conversationStarters[objIdx]
    }

    clear() {
        this.name = "";
        this.title = "";
        this.persona = "";
        this.tones = [];
        this.answerExtension = "";
        this.instructions = "";
        this.account = "";
        this.files = [];
        this.id = "";
        this.prompt_id = "";
        this.prompts = [];
        this.typeAgent = "";
        this.rawFiles = [];
        this.channels = [];
        this.isLoading = false;
        this.isError = false;
        this.updatedAgentSuccessfully = false;
        this.sharedSuccessfully=false;
        this.deleteFile = "";
        this.updatedDate = "";
        this.createdDate = "";
        this.finishedInitialLoad = false;
        this.addConcierge = true;
        this.usePrompter = false;
        this.actions = [];
        this.conversationStarters = {
            "cs1": "",
            "cs2": "",
            "cs3": "",
            "cs4": ""
        }
        this.isUploadingFile = false;
        this.agentCreator = {};
        this.agentConfigureMetadata = {};
        this.agentSelected = {}
        this.sharedSuccessfully="";
        this.signature = "";
    
    }

    onChangeSignature(value){
        this.signature = value;
    }

    setSelectedPromptId(selectedPrompt){
        this.prompt_id = selectedPrompt.value;
        this.prompt = this.prompts.filter((prompt) => prompt.id === selectedPrompt.value)[0].human_instruction;
    }
    
    getAgentByID(agent_id) {
        let agentSelected = toJS(this.agents)[0];
        if (agent_id)
            agentSelected = toJS(this.agents)
                .filter((a) => a.id.includes(agent_id))
                .pop();
        
        const {
            name,
            human_instructions,
            insert_date,
            last_modified,
            knowledge_base,
            channels,
            id,
            domain,
            job_title,
            persona,
            tone,
            extended_answer,
            scope,
            actions_settings,
            actions,
            conversation_starters,
            photo_url,
            photo_file_name,
            add_to_concierge,
            signature,
            category,
            model,
            type,
            prompt_id,

        } = agentSelected;

        const currentPromptID = prompt_id ? prompt_id.split("#")[1] : null;
        const currentPrompt = this.prompts.filter((prompt) => prompt.id === currentPromptID)[0];
        
        this.setPhotoFileName(photo_file_name)
        this.agentSelected = agentSelected;
        this.name = name;
        this.instructions = human_instructions;
        this.createdDate = insert_date;
        this.updatedDate = last_modified;
        this.rawFiles = knowledge_base;
        this.files = knowledge_base.map((filePath) =>
            filePath.replace("s3://", "").split("/").splice(-1).pop()
        );
        this.channels = channels.map((channel) => channel.toLowerCase());
        this.id = id;
        this.prompt_id = currentPromptID;
        this.prompt = currentPrompt?.description || "";
        this.isConcierge = domain === "concierge";
        this.title = job_title;
        this.persona = "name" in persona ? persona["name"] === "" ? "None" : persona["name"] : "";
        this.tones = tone && Array.isArray(tone) ? tone : [];
        this.answerExtension = extended_answer ? "extensive" : "summarized";
        this.type = scope;
        this.typeAgent = type;
        this.actions = actions;
        this.actionsSettings = actions_settings
        this.domain = domain;
        this.photo_url = photo_url || "";
        this.signature = signature?.EMAIL || "";
        this.addConcierge = add_to_concierge === null ? true : add_to_concierge;
        if (conversation_starters.length) {
            this.conversationStarters = conversation_starters.reduce((acc, value, idx) => ({ ...acc, [`cs${idx + 1}`]: value }), {});
        } else {
            this.conversationStarters = {
                "cs1": "",
                "cs2": "",
                "cs3": "",
                "cs4": ""
            };
        }
        this.setAgentConfigureMetadata()
        this.category = category;
        if (category) {
            this.selectedAgentCategory = { value: category };
        }
        this.model = model;
        
    }

    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getAgent
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // *getAgents(customer_id, agent_id) {

    //     try {
    //         this.isLoading = true;
    //         this.isError = false;

    //         const response = yield API.graphql({
    //             query: getAgent,
    //             variables: { input: { customer_id } },
    //             authMode: 'AMAZON_COGNITO_USER_POOLS'
    //         });
    //         const agents = JSON.parse(response.data?.getAgent?.body);
    //         this.agents = agents.filter((agent) => agent.provider === "openai");

    //         this.getAgentByID(agent_id);
    //         this.agentCreator = agents.filter(agent => agent.domain === 'creator')?.[0]
    //         this.finishedInitialLoad = true;
    //     } catch (error) {
    //         this.isError = true;
    //     } finally {
    //         this.isLoading = false;
    //     }
    // }
    
    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getPrompt
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // *getPrompts(customer_id) {
    //     try {
    //         this.isLoading = true;
    //         this.isError = false;

    //         const response = yield API.graphql({
    //             query: getPrompt,
    //             variables: { input: { user_id: customer_id } },
    //             authMode: 'AMAZON_COGNITO_USER_POOLS'
    //         });
            
    //         if (response.data?.getPrompt?.body !== "prompt not found") {
    //             this.prompts = JSON.parse(response.data?.getPrompt?.body);
    //         }
    //     } catch (error) {
    //         this.isError = true;
    //     } finally {
    //         this.isLoading = false;
    //     }
    // }

    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getAgent
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // *getAgentPrompter(customer_id) {
    //     try {
    //         this.isLoading = true;
    //         this.isError = false;

    //         const response = yield API.graphql({
    //             query: getAgent,
    //             variables: { input: { customer_id, domain: 'prompter' } },
    //             authMode: 'AMAZON_COGNITO_USER_POOLS'
    //         });
    //         const agents = JSON.parse(response.data?.getAgent?.body);
    //         this.agentPrompter = agents[0]?.id;
    //         return agents;
            
    //     } catch (error) {
    //         this.isError = true;
    //     } finally {
    //         this.isLoading = false;
    //     }
    // }

    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query putAgent
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // *updateAgent(fileName) {
    //     if (!this.name) return;
    //     this.updatedAgentSuccessfully = false;
    //     try {
    //         this.showOverlay = true;
    //         this.isLoading = true;
    //         this.isError = false;
    //         let input = {
    //             channels: toJS(this.channels),
    //             customer_id: this.account,
    //             human_instructions: this.instructions,
    //             knowledge_base: toJS(this.rawFiles),
    //             name: this.name,
    //             prompt_id: this.prompt_id || "",
    //             type: this.typeAgent,
    //             prompt: this.instructions,
    //             job_title: this.title,
    //             persona: JSON.stringify({ name: '' }),
    //             tone: toJS(this.tones),
    //             extended_answer:
    //                 this.answerExtension.toLowerCase() === "extensive",
    //             scope: this.type,
    //             actions_settings: this.actionsSettings,
    //             actions: this.actions,
    //             actions_settings: this.actionsSettings.map(setting => JSON.stringify(setting)),
    //             add_to_concierge: this.addConcierge,
    //             use_prompter: this.usePrompter,
    //             conversation_starters: Object.values(this.conversationStarters),
    //             domain: this.domain,
    //             photo_url: fileName ?? this.photoFileName,
    //             signature: JSON.stringify({EMAIL: this.signature}),
    //             category: this.selectedAgentCategory?.value || this.category,
    //             model: this.llmModelSelected?.value
    //         };

    //         if (this.isDuplicating) {
    //             input.id = "";
    //         } else {
    //             input.id = this.id;
    //         }

    //         yield API.graphql({
    //             query: putAgent,
    //             variables: { input },
    //             authMode: 'AMAZON_COGNITO_USER_POOLS'
    //         });
    //         yield this.getAgents(this.account, this.id);
    //         this.updatedAgentSuccessfully = true;
    //     } catch (error) {
    //         if (
    //             error.errors.length &&
    //             error.errors[0].errorType === "Lambda:ExecutionTimeoutException"
    //         ) {
    //             //Wait 10secs in case this endpoint time outs (it times out because of Appsync's 30 seconds limit)
    //             yield new Promise((resolve) => setTimeout(resolve, 10000));
    //             yield this.getAgents(this.account, this.id);
    //             this.updatedAgentSuccessfully = true;
    //         } else {
    //             this.isError = true;
    //         }
    //     } finally {
    //         this.isDuplicating = false;
    //         this.isLoading = false;
    //         this.showOverlay = false;
    //     }
    // }

    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL queries putAgent y deleteAgentFile
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // *confirmRemoveFile() {
    //     this.updatedAgentSuccessfully = false;
    //     try {
    //         const filename = this.deleteFile;
    //         this.isDeleting = true;
    //         this.isLoading = true;
    //         this.isError = false;
    //         const filepath = toJS(this.rawFiles)
    //             .filter((file) => file.includes(filename))
    //             .pop();
    //         this.rawFiles = this.rawFiles.filter(
    //             (file) => !file.includes(filename)
    //         );
    //         this.files = this.files.filter((file) => !file.includes(filename));

    //         this.filesWithStatus = this.filesWithStatus.filter(
    //             (file) => file.document !== filename
    //         );

    //         const input = {
    //             channels: toJS(this.channels),
    //             customer_id: this.account,
    //             human_instructions: this.instructions,
    //             knowledge_base: toJS(this.rawFiles),
    //             name: this.name,
    //             prompt: this.instructions,
    //             id: this.id,
    //             job_title: this.title,
    //             persona: JSON.stringify({name: ''}),
    //             tone: toJS(this.tones),
    //             extended_answer:
    //                 this.answerExtension.toLowerCase() === "extensive",
    //             scope: this.type,
    //             actions: this.actions,
    //             add_to_concierge: this.addConcierge,
    //             use_prompter: this.usePrompter,
    //             conversation_starters: Object.values(this.conversationStarters),
    //             domain: this.domain,
    //             photo_url: this.photo_url,
    //             signature: JSON.stringify({EMAIL: this.signature})
    //         };

    //         const deleteFileData = {
    //             customer: this.account,
    //             assistant_id: this.id,
    //             s3_file_path: filepath,
    //         };

    //         this.deleteFile = "";

    //         if (!this.isDuplicating) {
    //             yield API.graphql({
    //                 query: putAgent,
    //                 variables: { input },
    //                 authMode: 'AMAZON_COGNITO_USER_POOLS'
    //             });

    //             yield API.graphql({
    //                 query: deleteAgentFile,
    //                 variables: {
    //                     input: deleteFileData,
    //                 },
    //                 authMode: 'AMAZON_COGNITO_USER_POOLS'
    //             });
    //             this.updatedAgentSuccessfully = true;
    //         }
    //     } catch (error) {
    //         this.isError = true;
    //     } finally {
    //         this.deleteFile = "";
    //         this.isLoading = false;
    //         this.isDeleting = false;
    //     }
    // }

    *getAgentConcierge(customer_id) {
        try {
            this.isLoading = true;
            this.isError = false;

            // GraphQL removed - commented out
            // const response = yield API.graphql({
            //     query: getAgent,
            //     variables: { input: { customer_id, domain: 'concierge' } },
            //     authMode: 'AMAZON_COGNITO_USER_POOLS'
            // });
            // const agents = JSON.parse(response.data?.getAgent?.body);
            // this.agentConcierge = agents[0]?.id;
        } catch (error) {
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }

    *uploadFile(filesToUpload, currentUploadedFilesLength, customer, fileRoute, onFileUpload, onError) {
        if (!Array.isArray(filesToUpload)) {
            filesToUpload = [filesToUpload];
        }

        for (const file of filesToUpload) {
            // Check the 512mb limit
            if (file?.size / 1e+6 > 512) {
                this.isError = true;
                return;
            }
        }

        try {
            this.uploadProgress = 0;
            this.isLoading = true;
            this.updatedAgentSuccessfully = false;
            this.isUploadingFile = true;

            for (const file of filesToUpload) {
                const fileName = this.removeSpecialCharacters(file.name);

                // GraphQL removed - commented out
                // const response = yield API.graphql({
                //     query: getUploadUrlFile,
                //     variables: {
                //         input: {
                //             customer: customer,
                //             file_name: fileName,
                //             file_type: file.type,
                //             file_route: fileRoute,
                //         },
                //     },
                //     authMode: 'AMAZON_COGNITO_USER_POOLS'
                // });

                // const uploadUrl = JSON.parse(response.data.getUploadUrlFile?.body);
                const uploadUrl = null;
                const s3Url = uploadUrl.split('?')[0].replace("https://", "s3://").replace(".s3.amazonaws.com", "");
                const formData = new FormData();
                formData.append("file", file);
                
                const config = {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        this.uploadProgress = percentCompleted;
                    },
                    headers: {
                        "Content-Type": file.type,
                    },
                };

                yield axios.put(uploadUrl, file, config);

                if (onFileUpload) {
                    onFileUpload({
                        uploadUrl: s3Url,
                        fileName: fileName,
                    });
                }
            }

            yield this.updateAgent();

        } catch (error) {
            this.isError = true;
            if (onError) {
                onError();
            }
        } finally {
            this.isLoading = false;
            this.isUploadingFile = false;
        }
    }

    *downloadFile(fileName, customer, fileRoute) {
        try {
            const isValid = [fileName, customer, fileRoute].every(element => element)
            
            if (!isValid) {
                return;
            } 

            // GraphQL removed - commented out
            // const response = yield API.graphql({
            //     query: getUrlFile,
            //     variables: {
            //         input: {
            //             customer: customer,
            //             file_name: fileName,
            //             file_route: fileRoute,
            //         },
            //     },
            //     authMode: 'AMAZON_COGNITO_USER_POOLS'
            // });

            // const fileUrl = JSON.parse(response.data.getUrlFile?.body);
            const fileUrl = null;
            window.open(fileUrl, '_blank');

        } catch (error) {
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }

    removeSpecialCharacters(string) {
        const withoutSpaces = string.replace(/\s/g, '_');
        const withoutSpecialChars = withoutSpaces.replace(/[^.\w\s]/gi, '');
        return withoutSpecialChars;
    };

    setFilesWithStatus(files) {
        this.filesWithStatus = files;
    }

    setAgentConfigureMetadata(){
        this.agentConfigureMetadata = {
            selected_agent_id: this.id,
            additional_message: `{ "name": "${this.name}", "instruction": "${JSON.stringify(this.instructions)}", "description": "${this.title}", "conversation_starters": ${Object.values(this.conversationStarters)}}`
        }
    }

    updateFromConversation(key, value){

        if(key === 'conversation_starters'){
            return this.conversationStarters = value.reduce((acc, value, idx) => ({ ...acc, [`cs${idx + 1}`]: value }), {});
        }

        const keyDict = {
            name: 'name',
            instruction: 'instructions',
            description: 'title',
        }

        this[keyDict[key]] = value
    }
    
    *fetchResources(accountId, agentId, userId) {
        try {
            this.isLoading = true;
            this.isError = false;
            const input = {
                account_id: accountId,
                user_id: userId,
                id: agentId
            }
            
            // GraphQL removed - commented out
            // const response = yield API.graphql({
            //     query: getResources,
            //     variables: { input },
            //     authMode: 'AMAZON_COGNITO_USER_POOLS'
            // });
            
            // this.resources = JSON.parse(response.data?.getResources?.body);
            this.resources = [];
            
        } catch (error) {
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }

    *fetchGenerateAvatar(customer_id) {
        try {
            this.isLoading = true;
            this.isError = false;

            const input = {
                instructions: this.instructions,
                customer_id
            }
            
            // GraphQL removed - commented out
            // const response = yield API.graphql({
            //     query: putGenerateAvatar,
            //     variables: { input },
            //     authMode: 'AMAZON_COGNITO_USER_POOLS'
            // });

            // const parsedContent = JSON.parse(response.data.putGenerateAvatar?.body);
            // this.setPhotoUrl(parsedContent.file_url);
            // this.setPhotoFileName(parsedContent.file_name);
            // return parsedContent;
            return null;
            
        } catch (error) {
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }
    
    *updateUserResources(accountId, agentId, users) {
        this.sharedSuccessfully=false;
        try {
            this.isLoading = true;
            this.isError = false;
            const uniqueUsers = users.filter((user, index, self) =>
              index === self.findIndex((t) => t.id === user.id)
            );
            
            const input = {
                account_id: accountId,
                id: agentId,
                users: uniqueUsers
            }
            // GraphQL removed - commented out
            // yield API.graphql({
            //     query: putUserResources,
            //     variables: { input },
            //     authMode: 'AMAZON_COGNITO_USER_POOLS'
            // });
            // this.sharedSuccessfully=true;
        } catch (error) {
            this.isError = true;
            this.sharedSuccessfully=false;
        } finally {
            this.isLoading = false;
        }
    }

    *uploadAgentPhoto(file, customerId) {
        if (!file) return;
    
        try {
            this.isUploadingFile = true;
            this.isError = false;

            const fileName = this.removeSpecialCharacters(`${customerId}_${uuidv4()}.${file.name.split('.').pop()}`);
            this.setPhotoFileName(fileName);

            // GraphQL removed - commented out
            // const response = yield API.graphql({
            //     query: getUploadUrlFile,
            //     variables: {
            //         input: {
            //             customer: customerId,
            //             file_name: fileName,
            //             file_type: file.type,
            //             file_route: "assistants_photos",
            //             overwrite: true,
            //         },
            //     },
            //     authMode: "AMAZON_COGNITO_USER_POOLS",
            // });
            const response = { data: { getUploadUrlFile: { body: JSON.stringify({}) } } };
    
            const uploadUrl = JSON.parse(response.data.getUploadUrlFile?.body);
    
            const config = {
                headers: {
                    "Content-Type": file.type,
                },
            };
            yield axios.put(uploadUrl, file, config);

        } catch (error) {
            this.isError = true;
        } finally {
            this.isUploadingFile = false;
        }
    }
    
    setPhotoUrl(photoUrl){
        this.photo_url = photoUrl;
    }
    
    setUsersResources(user){
        this.usersResources.push(user);
    }
    
    removeUserResource(userId){
        const index = this.usersResources.findIndex(item => item.id === userId);
        if (index !== -1) {
            this.usersResources.splice(index, 1);
        }
    }
    
    setChosenPolicy(policy){
        this.chosenPolicy = policy;
    }

    onAgentTypeChange = (value) => {
        this.type = value;
    };

    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query deleteAgentFile
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // *deleteAgentFile(customer, assistant_id) {
    //     this.isLoading = true;
    //     try {
    //       yield API.graphql({
    //         query: deleteAgentFile,
    //         variables: {
    //           input: {
    //             customer: customer,
    //             s3_file_path: this.rawFiles,
    //             assistant_id: assistant_id,
    //           },
    //         },
    //         authMode: 'AMAZON_COGNITO_USER_POOLS',
    //       });
    //       return { success: true };
    //     } catch (error) {
    //       this.isError = true;
    //       return { success: false, errorType: "exception" };
    //     } finally {
    //       this.isLoading = false;
    //     }
    // }

      // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query preDeleteAgent
      // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
      
      // *preDeleteAgent() {
      //   this.isLoading = true;
      //   this.isConfirm = false;

      //   try {
      //       const res = yield API.graphql({
      //           query: preDeleteAgent,
      //           variables: {
      //               input: {
      //                   customer_id: this.account,
      //                   id: this.id,
      //                   providers: ["openai"],
      //               },
      //           },
      //           authMode: 'AMAZON_COGNITO_USER_POOLS'
      //       });

      //       const result = res?.data?.preDeleteAgent;
      //       if (result && result.statusCode === "200") {
      //           return { success: true };
      //       } else {
      //           return { success: false, errorType: result?.errorType || "unknown", body: result?.body };
      //       }
      //   } catch (error) {
      //       return { success: false, errorType: "exception" };
      //   } finally {
      //       this.isLoading = false;
      //   }
      // }

    setSelectedCategory = (category) => {
        this.selectedCategory = category;
    };

    setSelectedAgentCategory = (category) => {
        this.selectedAgentCategory = category;
    };

    setAgentCategories = (categories) => {
        this.agentCategories = categories;
    };

    // [DEPRECATED_GRAPHQL] - Para eliminación: Usa GraphQL query getCategories
    // TODO: Eliminar después de verificar que nuevas implementaciones funcionan correctamente
    
    // *fetchCategories() {
    //     try {
    //         this.isLoading = true;
    //         this.isError = false;

    //         const response = yield API.graphql({
    //             query: getCategories,
    //             authMode: 'AMAZON_COGNITO_USER_POOLS'
    //         });
    //         const categoriesData = JSON.parse(response.data.getCategories.body);
    //         this.setAgentCategories(categoriesData);
    //     } catch (error) {
    //         this.isError = true;
    //         this.errorMessage = "Error fetching categories";
    //     } finally {
    //         this.isLoading = false;
    //     }
    // }

    setLlmModelSelected = (model) => {
        this.llmModelSelected = model;
    };

}

export default EditAgentStore;
